import { post } from "./utils";

export const verifyEmail = async (code: string) => await post("profile/verify-email", { code: code });
